import * as api from '../api/authorization';
import { toGroup, toUser } from '../converters/permissionsConverter';
import { asyncAction } from './common';

export const fetchPermissions = () =>
  asyncAction('FETCH_AUTHORIZATION_PERMISSIONS', api.fetchPermissions());

export const fetchGroups = () => asyncAction('FETCH_AUTHORIZATION_GROUPS', api.fetchGroups());

export const updateGroup = (group) =>
  asyncAction('UPDATE_AUTHORIZATION_GROUP', api.saveGroup(toGroup(group)));

export const deleteGroup = (groupId) =>
  asyncAction('DELETE_AUTHORIZATION_GROUP', api.deleteGroup(groupId));

export const fetchUsers = () => asyncAction('FETCH_AUTHORIZATION_USERS', api.fetchUsers());

export const updateUser = (user) =>
  asyncAction('UPDATE_AUTHORIZATION_USER', api.saveUser(toUser(user)));

export const deleteUser = (userId) =>
  asyncAction('DELETE_AUTHORIZATION_USER', api.deleteUser(userId));

export const startUpdateGroup = (group = null) => ({
  type: 'UPDATE_AUTHORIZATION_GROUP',
  group,
});

export const cancelUpdateGroup = () => ({
  type: 'CANCEL_UPDATE_AUTHORIZATION_GROUP',
});

export const setGroupId = (groupId) => ({
  type: 'UPDATE_SET_AUTHORIZATION_GROUP_ID',
  groupId,
});

export const setGroupPermissions = (permissions) => ({
  type: 'UPDATE_SET_AUTHORIZATION_GROUP_PERMISSIONS',
  permissions,
});

export const startUpdateUser = (user = null) => ({
  type: 'UPDATE_AUTHORIZATION_USER',
  user,
});

export const cancelUpdateUser = () => ({
  type: 'CANCEL_UPDATE_AUTHORIZATION_USER',
});

export const setUserId = (userId) => ({
  type: 'UPDATE_SET_AUTHORIZATION_USER_ID',
  userId,
});

export const setUserPermissions = (permissions) => ({
  type: 'UPDATE_SET_AUTHORIZATION_USER_PERMISSIONS',
  permissions,
});

export const setUserGroups = (groups) => ({
  type: 'UPDATE_SET_AUTHORIZATION_USER_GROUPS',
  groups,
});

export const setTabKey = (key) => ({
  type: 'UPDATE_SET_AUTHORIZATION_TAB_KEY',
  key,
});
